<template>
  <div v-if="canManageAttendance" class="bg-white rounded-xl border border-gray-100 shadow-sm p-5">
    <!-- Header -->
    <div class="flex items-center justify-between mb-4">
      <div class="flex items-center gap-2">
        <div class="w-8 h-8 rounded-lg bg-teal-50 text-teal-600 flex items-center justify-center">
          <i class="pi pi-check-circle text-sm"></i>
        </div>
        <h3 class="font-bold text-gray-800 text-sm">Attendance</h3>
      </div>
    </div>

    <!-- Today's stats -->
    <div v-if="attendanceToday" class="grid grid-cols-3 gap-2 mb-3">
      <div class="text-center px-2 py-2 rounded-lg bg-primary/10">
        <p class="text-sm font-bold text-primary">{{ attendanceToday.present }}</p>
        <p class="text-[10px] text-primary">Present</p>
      </div>
      <div class="text-center px-2 py-2 rounded-lg bg-red-50">
        <p class="text-sm font-bold text-red-700">{{ attendanceToday.absent }}</p>
        <p class="text-[10px] text-red-600">Absent</p>
      </div>
      <div class="text-center px-2 py-2 rounded-lg bg-amber-50">
        <p class="text-sm font-bold text-amber-700">{{ attendanceToday.late }}</p>
        <p class="text-[10px] text-amber-600">Late</p>
      </div>
    </div>

    <div v-if="attendanceToday" class="mb-3">
      <div class="flex items-center justify-between text-[10px] text-gray-500 mb-1">
        <span>Today's attendance rate</span>
        <span class="font-medium">{{ attendanceToday.percentage }}%</span>
      </div>
      <div class="w-full bg-gray-200 rounded-full h-1.5">
        <div
          class="h-1.5 rounded-full bg-teal-500 transition-all"
          :style="{ width: attendanceToday.percentage + '%' }"
        />
      </div>
    </div>

    <!-- Quick action -->
    <div class="pt-3 border-t border-gray-100">
      <router-link
        :to="{ name: 'admin-daily-attendance' }"
        class="flex items-center gap-1.5 text-xs text-teal-600 hover:text-teal-800 font-medium"
      >
        <i class="pi pi-calendar-plus text-[10px]"></i>
        Mark Attendance
      </router-link>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useStaffDashboard } from '@/composables/useStaffDashboard';

const { canManageAttendance } = useStaffDashboard();

defineProps<{
  attendanceToday?: {
    present: number
    absent: number
    late: number
    percentage: number
    total: number
  } | null
}>();
</script>
